import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const isHeader = jsonNode.type === 'Heading';
  const hasStyledAs = data?.styledAs != null;

  // This specific styledAs override is only used in the "Commerce Order Confirmation Container"
  return {
    needed: isHeader && hasStyledAs,
    logData: {
      msg: 'Delete styledAs on Header',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // Check if "Commerce Order Container Heading" has had its styles overridden
      const updateTag = data.styledAs === 'h4';
      if (updateTag) {
        jsonNode.tag = 'h4';
        data.tag = 'h4';
      }

      // eslint-disable-next-line webflow/no-delete
      delete data.styledAs;
    },
  };
};
